var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocker(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 460 322.1",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 460 322.1"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#099cec}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x39_7-docker"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 47.5,
    height: 43.2,
    x: 204,
    y: 52.3,
    className: "st0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 47.5,
    height: 42.7,
    x: 204,
    y: 104.1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 47.5,
    height: 43.2,
    x: 147.9,
    y: 52.3,
    className: "st0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 47.5,
    height: 42.7,
    x: 260.2,
    y: 104.1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 47.5,
    height: 43.6,
    x: 204,
    className: "st0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 47.5,
    height: 43.2,
    x: 91.7,
    y: 52.3,
    className: "st0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 47.5,
    height: 42.7,
    x: 147.9,
    y: 104.1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.4,124.1c-10.4-7-34.2-9.5-52.5-6c-2.4-17.2-12-32.3-29.5-45.8l-10.1-6.7l-6.7,10.1 c-13.2,20-16.8,52.9-2.7,74.6c-6.3,3.4-18.5,8-34.8,7.7H1.8c-6.3,36.5,4.2,83.9,31.6,116.5C60,306,100,322.1,152.3,322.1 c113.1,0,196.9-52.1,236-146.8c15.4,0.3,48.6,0.1,65.6-32.5c1.1-1.8,4.7-9.5,6.1-12.3L450.4,124.1z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.2 104.1 83.1 104.1 35.7 104.1 35.7 146.8 83.2 146.8",
    className: "st0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 47.5,
    height: 42.7,
    x: 91.7,
    y: 104.1,
    className: "st0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocker);
export default __webpack_public_path__ + "static/media/docker.294e4ef13e8d16cc0812f421ada97a71.svg";
export { ForwardRef as ReactComponent };